<template>
  <div class="sornBG lightBG">
    <h1>App Selection</h1>
    <v-container class="col-3">
      <v-list dense>
        <v-list-item v-for="(item, index) in sortedButtons" :key="item.id">
          <v-list-item-content>
            <v-list-item-title>
              <v-btn
                :id="item.id"
                rounded
                class="sidebar-btn white--text"
                color="primary"
                block
                @click="toApp(index)"
                >{{ item.name }}</v-btn
              >
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-4 mb-2"></v-divider>
        <v-row>
          <v-col cols="6">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  <v-btn
                    id="myAccount"
                    rounded
                    class="sidebar-btn white--text"
                    color="primary"
                    block
                    @click="toMyAccount()"
                    ><v-icon left dark>mdi-account-circle</v-icon> My Account
                  </v-btn>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col cols="6">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  <v-btn
                    id="logoutUser"
                    rounded
                    class="sidebar-btn white--text"
                    color="primary"
                    block
                    @click="logout"
                    ><v-icon left dark>mdi-logout</v-icon> Logout</v-btn
                  >
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>
      </v-list>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import { openApp } from '../shared/helpers'

export default {
  name: 'appSelection',
  data() {
    return {
      appButtons: [],
    }
  },
  async mounted() {
    //await this.refreshUser()
    if (this.userToAppMappings) {
      this.setAppButtons()
    }
  },
  methods: {
    ...mapActions(['logoffUser']),
    ...mapMutations(['refreshUser']),
    logout() {
      this.$store.dispatch('logoffUser')
    },
    toMyAccount() {
      this.$router.push('myAccount')
    },
    setAppButtons() {
      this.appButtons = []
      if (this.userToAppMappings.length === 1) {
        const app = this.applications.find(
          app => app.id === this.userToAppMappings[0].application_id,
        )
        switch (app.description.toLowerCase()) {
          case 'cad':
            if (window.location.hostname !== 'localhost') {
              openApp(
                `${window.location.protocol}//${window.location.hostname}/cad`,
              )
            } else {
              openApp(process.env.VUE_APP_CAD_URL)
            }
            break
          case 'admin':
            if (window.location.hostname !== 'localhost') {
              openApp(
                `${window.location.protocol}//${window.location.hostname}/admin`,
              )
            } else {
              openApp(process.env.VUE_APP_ADMIN_URL)
            }
            break
          case 'map':
            if (window.location.hostname !== 'localhost') {
              openApp(
                `${window.location.protocol}//${window.location.hostname}/map`,
              )
            } else {
              openApp(process.env.VUE_APP_MAP_URL)
            }
            break
          case 'reports':
            if (window.location.hostname !== 'localhost') {
              openApp(
                `${window.location.protocol}//${window.location.hostname}/reports`,
                true
              )
            } else {
              openApp(process.env.VUE_APP_REPORTS_URL, true)
            }
            break
          case 'mobile':
            if (window.location.hostname !== 'localhost') {
              openApp(
                `${window.location.protocol}//${window.location.hostname}/mobile/WorkstationSelection`,
              )
            } else {
              openApp(process.env.VUE_APP_MOBILE_URL)
            }
            break
          default:
            break
        }
      } else if (this.userToAppMappings.length !== 0) {
        this.userToAppMappings.forEach(mapping => {
          const app = this.applications.find(
            app => app.id === mapping.application_id,
          )
          switch (app.description.toLowerCase()) {
            case 'cad':
              if (window.location.hostname !== 'localhost') {
                this.appButtons.push({
                  name: 'Cad',
                  url: `${window.location.protocol}//${window.location.hostname}/cad`,
                  id: 'cad',
                })
              } else {
                this.appButtons.push({
                  name: 'Cad',
                  url: process.env.VUE_APP_CAD_URL,
                  id: 'cad',
                })
              }
              break
            case 'admin':
              if (window.location.hostname !== 'localhost') {
                this.appButtons.push({
                  name: 'Admin',
                  url: `${window.location.protocol}//${window.location.hostname}/admin`,
                  id: 'admin',
                })
              } else {
                this.appButtons.push({
                  name: 'Admin',
                  url: process.env.VUE_APP_ADMIN_URL,
                  id: 'admin',
                })
              }
              break
            case 'map':
              if (window.location.hostname !== 'localhost') {
                this.appButtons.push({
                  name: 'Map',
                  url: `${window.location.protocol}//${window.location.hostname}/map`,
                  id: 'map',
                })
              } else {
                this.appButtons.push({
                  name: 'Map',
                  url: process.env.VUE_APP_MAP_URL,
                  id: 'map',
                })
              }
              break
            case 'reports':
              if (window.location.hostname !== 'localhost') {
                this.appButtons.push({
                  name: 'Reports',
                  url: `${window.location.protocol}//${window.location.hostname}/reports`,
                  id: 'reports',
                })
              } else {
                this.appButtons.push({
                  name: 'Reports',
                  url: process.env.VUE_APP_REPORTS_URL,
                  id: 'reports',
                })
              }
              break
            case 'mobile':
              if (window.location.hostname !== 'localhost') {
                this.appButtons.push({
                  name: 'Mobile',
                  url: `${window.location.protocol}//${window.location.hostname}/mobile/WorkstationSelection`,
                  id: 'mobile',
                })
              } else {
                this.appButtons.push({
                  name: 'mobile',
                  url: process.env.VUE_APP_MOBILE_URL,
                  id: 'mobile',
                })
              }
              break
            default:
              break
          }
        })
      }
      const unique = []
      this.appButtons.forEach(e => {
        if (unique.some(x => x.name === e.name)) return
        unique.push(e)
      })
      this.appButtons = unique
    },
    toApp(e) {
      if (this.sortedButtons[e].url !== null) {
        if (
          this.sortedButtons[e].name === 'Cad' &&
          document.cookie.split('; ').find(row => row.startsWith('cad_session'))
        ) {
          let r = confirm(
            'A session of cad has already been started. Would you like to close this session and open a new session?',
          )
          if (r === true) {
            document.cookie = `close_cad=;domain=${window.location.hostname};path=/;`
            let component = this
            setTimeout(function() {
              openApp(component.sortedButtons[e].url)
            }, 2000)
          }
        } else if(this.sortedButtons[e].name === 'Reports') {
          openApp(this.sortedButtons[e].url, true)
        } else {
          openApp(this.sortedButtons[e].url)
        }
      } else {
        if (this.sortedButtons[e].id === 'logoutUser') {
          this.logoutUser()
        } else if (this.sortedButtons[e].id === 'myAccount') {
          this.$router.push('/myAccount')
        }
      }
    },
    logoutUser() {
      this.logoffUser()
    },
  },
  computed: {
    ...mapState(['applications', 'user', 'userToAppMappings']),
    sortedButtons() {
      const myButtons = JSON.parse(JSON.stringify(this.appButtons))
      return myButtons.sort((a, b) => {
        return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
      })
    },
  },
  watch: {
    async userToAppMappings(newVal) {
      this.setAppButtons()
    },
  },
}
</script>

<style>
.sornBG {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
}
.center {
  align-items: center;
}
</style>
